import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=87bad49a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bad49a')) {
      api.createRecord('87bad49a', component.options)
    } else {
      api.reload('87bad49a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=87bad49a&", function () {
      api.rerender('87bad49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28e3WUjVL6GD6/JS/videoIframe.vue"
export default component.exports